import { ClikRequestType } from "../../../../graphql/generated.ts";

export const pendingTooltipLabel =
  "Getting Clik Result takes some time. If the status is Pending, please try refreshing the page in a few minutes.";

export const requestTypes: Record<ClikRequestType, string> = {
  NAE: "New Application Enquiry",
  ME: "Monitoring Enquiry",
};
